import React, { useState, useEffect } from 'react'
import CardTitle from '@auteco/components/sharedComponents/CardTitle'
import { PqrsFinder, PqrsTimeline } from '@auteco/components/finderComponents'
import { getPqrs } from '@auteco/services/finderServices'
import { Pagination } from '@material-ui/lab'
import pagination from '@auteco/utils/pagination'

const SearchPQRs = () => {
    const [pqrs, setPqrs] = useState([])
    const [currentPage, setCurrentPage] = useState([])
    const [postPerPage] = useState(4);

    const getPqrsDoc = async ({ doc }) => {
        const { data } = await getPqrs({ params: doc })
        if (data) {
            setPqrs(data)
        }
        console.log('response', data)
    }

    const { currentPosts, totalPages } = pagination(pqrs, currentPage, postPerPage)
    const onChangepage = (e, page) => {
        setCurrentPage(page);
    }

    useEffect(() => {
        setCurrentPage(1)
    }, [pqrs])
    return (
        <>
            <CardTitle title="Buscar PQRs por documento" />
            <PqrsFinder getPqrsDoc={getPqrsDoc} />
            <PqrsTimeline pqrs={currentPosts} />
            <Pagination count={totalPages} onChange={onChangepage} defaultPage={1} />
        </>
    )
}

export { SearchPQRs }